import { render, staticRenderFns } from "./societyActivityEdit.vue?vue&type=template&id=0c529256&scoped=true&"
import script from "./societyActivityEdit.vue?vue&type=script&lang=js&"
export * from "./societyActivityEdit.vue?vue&type=script&lang=js&"
import style0 from "./societyActivityEdit.vue?vue&type=style&index=0&id=0c529256&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c529256",
  null
  
)

export default component.exports